import Container from "../../components/Container"
import { Input, Button } from "@mobi/ds"
import classNames from "classnames"
import useHero from "./useHero"

import "./Hero.scss"

const Hero = ({ formRef }) => {
  const { isValid, isValidDocument, field, control, handleSubmitForm } =
    useHero()

  return (
    <section className="hero">
      <Container>
        <div className="hero__content">
          <div className="hero__titles">
            <h1 className="hero__title"> A vida não tem roteiro </h1>

            <h2 className="hero__subtitle">
              Conte com as soluções do Itaú e opções de pagamento ideais para o
              seu momento
            </h2>
          </div>

          <div className="hero__image-wrapper">
            <img
              src="/images/landing/hero-fe-torres.png"
              className="hero__image"
              alt="Imagem de uma mulher em um estúdio, segurando um celular laranja "
              width="483"
              height="398"
            />
          </div>

          <div className="hero__form-wrapper" ref={formRef}>
            <form className="hero__form">
              <p className="hero__form-title">Consulte seus descontos</p>

              <Input.Cpf
                value={field.value}
                name={field.name}
                ref={field.ref}
                control={control}
                label="Digite seu CPF"
              />

              <div
                className={classNames("hero__hidden-fields", {
                  "hero__hidden-fields--expandend": isValidDocument,
                })}
              >
                <Input.Cellphone
                  name="phone"
                  label="Digite seu celular"
                  control={control}
                />
              </div>

              <Button
                className="hero__button-submit"
                disabled={!isValid || !isValidDocument}
                type="submit"
                onClick={handleSubmitForm}
                fluid
              >
                Consultar CPF
              </Button>
            </form>
          </div>
        </div>
      </Container>
    </section>
  )
}

export default Hero
